import { render, staticRenderFns } from "./AgentPatientManagement.vue?vue&type=template&id=1f8f46a6&scoped=true"
import script from "./AgentPatientManagement.vue?vue&type=script&lang=js"
export * from "./AgentPatientManagement.vue?vue&type=script&lang=js"
import style0 from "./AgentPatientManagement.vue?vue&type=style&index=0&id=1f8f46a6&prod&lang=scss&scoped=true"
import style1 from "./AgentPatientManagement.vue?vue&type=style&index=1&id=1f8f46a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8f46a6",
  null
  
)

export default component.exports